import {
  Box,
  CircularProgress,
  Grid,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { IoSearchOutline } from 'react-icons/io5';
import { GoArrowSwitch } from 'react-icons/go';
import axios from 'axios';
import Web3 from 'web3';
import cx from 'classnames';
import BigNumber from 'bignumber.js';
import { getConnections, waitForTransactionReceipt } from '@wagmi/core';

import Enshield from '../../Assets/images/logo.svg';
import TopNavBar from '../../Components/TopBar/Navbar';

import MaterialCheckbox from '../../Components/CheckBox/MaterialCheckbox';
import ETHLogo from '../../Assets/logos/ETHLogo.png';
import USDTLogo from '../../Assets/logos/USDTLogo.png';
import GradiantButton from '../../Components/Button/GradiantButton';
import CustomText_input from '../../Components/Input/CustomText_input';
import {
  CustomTablePagination,
  StyledTableCell,
  StyledTableRow,
} from '../../Components/MaterialTableStyle/StyleTableCell';
import CustomTooltip from '../../Components/Input/CustomToolTip';
import { FormatDate } from '../../Components/DateFormats/DateFromat';
import SvgLogo from '../../Assets/images/logo.svg';
import OCOCIon from '../../Assets/images/logo.svg';
import CustomModal from '../../Components/Modal/CustomModal';
import CustomButton from '../../Components/Button/CustomButton';

import InputRadio from '../../Components/InputRadio/InputRadio';
import PopUpModal from '../../Components/walletaction/PopupModal';

import { CiWallet } from 'react-icons/ci';
import { toast } from 'react-toastify';
import { IoMdCheckmarkCircleOutline, IoMdSpeedometer } from 'react-icons/io';
import { TbRefreshDot } from 'react-icons/tb';

import { useAccount } from 'wagmi';

import PrivateSaleABI from '../../ContractABI/OZKPrivateSale.json';
import USDTABI from '../../ContractABI/USDTToken.json';

import {
  REACT_APP_RPC_URL,
  REACT_APP_USDT_TOKEN,
  REACT_APP_TRANSACTION_HASHLINK,
  REACT_APP_PRIVATE_SALE,
  REACT_APP_BUY_USD_TOPIC0,
  REACT_APP_BUY_ETH_TOPIC0,
  REACT_APP_VESTED_TOPIC0,
  REACT_APP_START_BLOCK,
  REACT_APP_USDT_DECIMALS,
} from '../../Config/Config';
import NotConnectedModal from '../../Components/Modal/NotConectedModal';
import { useDepositContext } from '../../context/depositContext';
import wagmiAdapterConfig from '../../Config/WagmiConfig';

const BuyNow = () => {
  const { ethPrice, usdPrice, isWhitelisted, startDate, endDate } =
    useDepositContext();
  const { isConnected, address } = useAccount();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState('');

  const connections = getConnections(wagmiAdapterConfig);

  const [RemainingTime, setRemainingTime] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [Search, setSearch] = useState('');
  const [Loader, setLoader] = useState(true);
  const [RowsPerPage, setRowsPerPage] = useState(10);
  const [Page, setPage] = useState(0);
  const [Page1, setPage1] = useState(1);

  const [BuyNowModal, setBuyNowModal] = useState(false);
  const [WalletActionModal, setWalletActionModal] = useState(false);
  const [Loader1, setLoader1] = useState(false);
  const [Loader2, setLoader2] = useState(false);
  const [Loader3, setLoader3] = useState(false);
  const [CoinAmount, setCoinAmount] = useState('');

  const [ethWalletBalance, setEthWalletBalance] = useState(0);
  const [usdtWalletBalance, setUsdtWalletBalance] = useState(0);
  const [buylisttransaction, setbuylisttransaction] = useState([]);
  const [buysearchlisttransaction, setbuysearchlisttransaction] = useState([]);
  const [popupmodal, setpopupmodal] = useState(false);
  const [poptext, setpoptext] = useState('');
  const [Hashlink, setHashlink] = useState('');
  const [tokenAmount, setTokenAmount] = useState(0);

  const [swap, setswap] = useState(false);

  const [selected_radio, setSelected_radio] = useState('ETH');

  const [isChecked, setIsChecked] = useState(false);
  const [isDisclaimerChecked, setIsDisclaimerChecked] = useState(false);

  useEffect(() => {
    if (isConnected) {
      if (isWhitelisted) {
        return;
      }
      setModalOpen(true);
      setModalContent(
        'You have to be whitelisted in order to access page content!',
      );
      return;
    }

    setModalOpen(true);
    setModalContent(
      'You have to be connected in order to access page content!',
    );
  }, [isConnected, isWhitelisted]);

  const HandleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    setPage1(1);
  };

  const HandleChangePage = (event, newPage) => {
    setPage(newPage);
    setPage1(newPage + 1);
  };

  const HandleChangePagePrev = (event, newPage) => {
    setPage(newPage - 1);
    setPage1(newPage);
  };

  const CalculateTimeRemaining = (endtime) => {
    const now = new Date();
    const timeDifference = endtime.getTime() - now.getTime();
    if (timeDifference <= 0) {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      };
    }

    // Calculate remaining days, hours, minutes, and seconds
    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
    );
    const minutes = Math.floor(
      (timeDifference % (1000 * 60 * 60)) / (1000 * 60),
    );
    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

    return {
      days,
      hours,
      minutes,
      seconds,
    };
  };

  useEffect(() => {
    if (endDate && endDate !== 0) {
      const timerInterval = setInterval(() => {
        setRemainingTime(CalculateTimeRemaining(new Date(endDate * 1000)));
      }, 1000);
      CalculateTimeRemaining(new Date(endDate * 1000));
      return () => clearInterval(timerInterval);
    }
  }, [endDate]);

  useEffect(() => {
    if (Loader) {
      setTimeout(() => {
        setLoader(false);
      }, 1000);
    }
  }, [Loader]);

  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  });

  const web3 = new Web3(REACT_APP_RPC_URL);

  useEffect(() => {
    if (isConnected) {
      getWalletBalance();
    }
    fetchBuyTransaction();
  }, [isConnected]);

  const getWalletBalance = async () => {
    try {
      const walletBalanceEth = await web3.eth.getBalance(address);
      const ethBalance = web3.utils.fromWei(
        walletBalanceEth.toString(),
        'ether',
      );
      setEthWalletBalance(Number(ethBalance));
    } catch (err) {
      console.log('ErrorinUserdetailbnb==>', err);
    }

    try {
      const USDToken = new web3.eth.Contract(USDTABI, REACT_APP_USDT_TOKEN);
      const usdtInWalletBalance = await USDToken.methods
        .balanceOf(address)
        .call();
      const usdtBalance = web3.utils.fromWei(
        usdtInWalletBalance.toString(),
        Number(REACT_APP_USDT_DECIMALS),
      );

      console.log('usdtBalance==>', usdtBalance);
      setUsdtWalletBalance(usdtBalance);
    } catch (err) {
      console.log('ErrorinUserdetailbusd==>', err);
    }
  };

  const fetchBuyTransaction = async () => {
    try {
      if (web3 != null) {
        const result = await axios.post(
          REACT_APP_RPC_URL,
          {
            jsonrpc: '2.0',
            id: 1,
            method: 'eth_getLogs',
            params: [
              {
                address: REACT_APP_PRIVATE_SALE,
                topics: [REACT_APP_BUY_USD_TOPIC0],
                fromBlock: web3.utils.numberToHex(REACT_APP_START_BLOCK),
                toBlock: 'latest',
              },
            ],
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        );

        const resultArray = result.data.result;

        const reversedList = resultArray.map((e, i, a) => a[a.length - 1 - i]);

        const resultEth = await axios.post(
          REACT_APP_RPC_URL,
          {
            jsonrpc: '2.0',
            id: 1,
            method: 'eth_getLogs',
            params: [
              {
                address: REACT_APP_PRIVATE_SALE,
                topics: [REACT_APP_BUY_ETH_TOPIC0],
                fromBlock: web3.utils.numberToHex(REACT_APP_START_BLOCK),
                toBlock: 'latest',
              },
            ],
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        );

        const resultEthArray = resultEth.data.result;

        const reversedEthList = resultEthArray.map(
          (e, i, a) => a[a.length - 1 - i],
        );

        const transactionHistory = [];
        const transactionHistoryamt = [];

        await Promise.all(
          reversedList.map(async (event) => {
            const data1 = web3.eth.abi.decodeLog(
              [
                {
                  indexed: true,
                  internalType: 'address',
                  name: 'user',
                  type: 'address',
                },
                {
                  indexed: false,
                  internalType: 'uint256',
                  name: 'amount',
                  type: 'uint256',
                },
              ],
              event.data, // Contains non-indexed parameters
              event.topics.slice(1), // Exclude topic0 (event signature hash)
            );

            if (data1.user === address) {
              const transactionHash = event.transactionHash;

              // Fetch transaction receipt
              const receipt = await web3.eth.getTransactionReceipt(
                transactionHash,
              );

              // Decode logs
              let tokenAmount = 0;
              const vestedEventABI = [
                {
                  indexed: true,
                  internalType: 'address',
                  name: 'user',
                  type: 'address',
                },
                {
                  indexed: false,
                  internalType: 'uint256',
                  name: 'amountAdded',
                  type: 'uint256',
                },
                {
                  indexed: false,
                  internalType: 'uint256',
                  name: 'totalAmount',
                  type: 'uint256',
                },
              ];
              receipt.logs.forEach((log) => {
                if (log.topics[0] === REACT_APP_VESTED_TOPIC0) {
                  // Decode Vested event
                  const vestedData = web3.eth.abi.decodeLog(
                    vestedEventABI,
                    log.data,
                    log.topics.slice(1), // Skip topic0 (event signature hash)
                  );
                  tokenAmount = web3.utils.fromWei(
                    vestedData.amountAdded,
                    'ether',
                  );
                }
              });

              const _amount = Number(data1.amount) / 1000000;
              const saleType = 'USDT';
              const block = await web3.eth.getBlock(
                web3.utils.hexToNumber(event.blockNumber),
              );
              const timestamp = Number(block.timestamp) * 1000;

              const time = String(new Date(timestamp)).slice(4, 21);
              const date = Number(timestamp);
              const transaction = {
                transactionHash,
                amount: _amount,
                tokenAmount: tokenAmount,
                saleType: saleType,
                time,
                date,
              };
              transactionHistoryamt.push(_amount);
              transactionHistory.push(transaction);
            }
          }),
          reversedEthList.map(async (event) => {
            const data1 = web3.eth.abi.decodeLog(
              [
                {
                  indexed: true,
                  internalType: 'address',
                  name: 'user',
                  type: 'address',
                },
                {
                  indexed: false,
                  internalType: 'uint256',
                  name: 'amount',
                  type: 'uint256',
                },
              ],
              event.data, // Contains non-indexed parameters
              event.topics.slice(1), // Exclude topic0 (event signature hash)
            );

            if (data1.user === address) {
              const transactionHash = event.transactionHash;
              // Fetch transaction receipt
              const receipt = await web3.eth.getTransactionReceipt(
                transactionHash,
              );

              // Decode logs
              let tokenAmount = 0;
              const vestedEventABI = [
                {
                  indexed: true,
                  internalType: 'address',
                  name: 'user',
                  type: 'address',
                },
                {
                  indexed: false,
                  internalType: 'uint256',
                  name: 'amountAdded',
                  type: 'uint256',
                },
                {
                  indexed: false,
                  internalType: 'uint256',
                  name: 'totalAmount',
                  type: 'uint256',
                },
              ];
              receipt.logs.forEach((log) => {
                if (log.topics[0] === REACT_APP_VESTED_TOPIC0) {
                  // Decode Vested event
                  const vestedData = web3.eth.abi.decodeLog(
                    vestedEventABI,
                    log.data,
                    log.topics.slice(1), // Skip topic0 (event signature hash)
                  );
                  tokenAmount = web3.utils.fromWei(
                    vestedData.amountAdded,
                    'ether',
                  );
                }
              });

              const _amount = web3.utils.fromWei(data1.amount, 'ether');
              const saleType = 'ETH';
              const block = await web3.eth.getBlock(
                web3.utils.hexToNumber(event.blockNumber),
              );
              const timestamp = Number(block.timestamp) * 1000;

              const time = String(new Date(timestamp)).slice(4, 21);
              const date = Number(timestamp);
              const transaction = {
                transactionHash,
                amount: _amount,
                tokenAmount: tokenAmount,
                saleType: saleType,
                time,
                date,
              };
              transactionHistoryamt.push(_amount);
              transactionHistory.push(transaction);
            }
          }),
        );
        transactionHistory.sort((a, b) => b.date - a.date);
        setbuysearchlisttransaction(transactionHistory);
        setbuylisttransaction(transactionHistory);
      }
    } catch (err) {
      console.log('Errorinfetchbuytion=>', err);
    }
  };

  const ConfirmedBuyNow = async () => {
    if (!connections || connections.length === 0) {
      toast.warn('No wallet connector found');
      return;
    }

    const walletProvider = await connections[0].connector.getProvider();

    if (!walletProvider) {
      toast.warn('Wallet provider not found');
      return;
    }

    const web3 = new Web3(walletProvider);

    const privateSaleContract = new web3.eth.Contract(
      PrivateSaleABI,
      REACT_APP_PRIVATE_SALE,
    );
    const TokenContract = new web3.eth.Contract(USDTABI, REACT_APP_USDT_TOKEN);

    setBuyNowModal(false);

    const timestamp = Math.floor(new Date().getTime() / 1000);

    if (selected_radio === 'ETH') {
      if (Number(ethWalletBalance) < Number(CoinAmount)) {
        setpoptext('Insufficient ETH In Your Wallet');
        setpopupmodal(true);
        return;
      }

      if (
        startDate !== 0 &&
        startDate < timestamp &&
        endDate !== 0 &&
        endDate > timestamp
      ) {
        try {
          setWalletActionModal(true);
          setLoader1(false);
          setLoader2(true);
          setLoader3(true);

          const ethAmount = web3.utils.toWei(CoinAmount.toString(), 'ether');
          const buytokens = await privateSaleContract.methods
            .deposit()
            .send({ from: address, value: ethAmount });

          if (buytokens.transactionHash) {
            setLoader2(false);
            setLoader3(false);
            setWalletActionModal(false);
            setHashlink(buytokens.transactionHash);
            getWalletBalance();
            fetchBuyTransaction();
            toast.success('Payment Completed Successfully');
            setpoptext('Payment Completed Successfully');
            ConvertTotoken(0);
            setpopupmodal(true);
          } else {
            toast.warn('Try again later!');

            setLoader2(false);
            setLoader3(false);
            setWalletActionModal(false);
          }
        } catch (err) {
          setLoader2(false);
          setLoader3(false);
          setWalletActionModal(false);

          console.log('Errorinbuybusd==>', err);
          toast('Something went wrong. Please try again!');
        }
      } else {
        setpoptext('Check Start Date and End Date');
        setpopupmodal(true);
        return;
      }
    } else if (selected_radio == 'USDT') {
      if (Number(usdtWalletBalance) < Number(CoinAmount)) {
        setpoptext('Insufficient USDT In Your Wallet');
        setpopupmodal(true);
        return;
      }

      if (
        startDate !== 0 &&
        startDate < timestamp &&
        endDate !== 0 &&
        endDate > timestamp
      ) {
        try {
          const allowance = await TokenContract.methods
            .allowance(address, REACT_APP_PRIVATE_SALE)
            .call();
          const usdtAmount = CoinAmount * 10 ** REACT_APP_USDT_DECIMALS;
          setWalletActionModal(true);
          setLoader1(true);
          setLoader2(true);
          setLoader3(true);
          if (Number(allowance) < Number(usdtAmount)) {
            const approve = await TokenContract.methods
              .approve(REACT_APP_PRIVATE_SALE, usdtAmount)
              .send({ from: address });
            await waitForTransactionReceipt(wagmiAdapterConfig, {
              hash: approve.transactionHash,
            });
          }
          setHashlink('');
          buyUsingUSDT(web3, usdtAmount);
        } catch (err) {
          setWalletActionModal(false);
          setLoader1(false);
          console.log('Errorinbuybusd==>', err);
          toast('Something went wrong. Please try again!');
        }
      } else {
        setpoptext('Check Start Date and End Date');
        setpopupmodal(true);
        return;
      }
    } else {
      setpoptext('Select Proper Token Type');
      setpopupmodal(true);
      return;
    }
  };

  const buyUsingUSDT = async (web3, usdtAmount) => {
    try {
      const privateSaleContract = new web3.eth.Contract(
        PrivateSaleABI,
        REACT_APP_PRIVATE_SALE,
      );

      setLoader1(false);

      const buytokens = await privateSaleContract.methods
        .deposit(usdtAmount)
        .send({ from: address });
      waitForTransactionReceipt(wagmiAdapterConfig, {
        hash: buytokens.transactionHash,
      });

      if (buytokens.transactionHash) {
        setHashlink(buytokens.transactionHash);
        setLoader2(false);
        setLoader3(false);
        setWalletActionModal(false);
        getWalletBalance();
        fetchBuyTransaction();
        toast.success('Payment Completed Successfully');
        setpoptext('Payment Completed Successfully');
        ConvertTotoken(0);
        setpopupmodal(true);
      } else {
        setLoader2(false);
        setLoader3(false);
        setWalletActionModal(false);
      }
    } catch (err) {
      setLoader2(false);
      setLoader3(false);
      setWalletActionModal(false);
      console.log('Error_in_BuyUsingBUSD==>', err);
    }
  };

  const buyToken = async () => {
    if (!isChecked) {
      setpoptext('Agree Terms and Conditions of Token Sale and Usage');
      setpopupmodal(true);
      return;
    }

    if (!isDisclaimerChecked) {
      setpoptext('Agree Disclaimer');
      setpopupmodal(true);
      return;
    }

    if (!isConnected || !address) {
      setpoptext('Connect Your Wallet');
      setpopupmodal(true);
      return;
    }

    console.log('CoinAmount==>', CoinAmount);

    if (!CoinAmount || Number(CoinAmount) <= 0) {
      toast('Enter Proper Token Amount');
      return;
    }

    const checkisostart = true;

    if (!checkisostart) {
      setpoptext('Presale Not Started Yet');
      setpopupmodal(true);
      return;
    }
    setBuyNowModal(true);
  };

  const CheckinScan = () => {
    if (!Loader3) {
      toast.success('Transaction Completed Successfully');
      setWalletActionModal(false);
    } else {
      toast.warn('Please wait...');
    }
  };

  const AmountFormat = (amount) => {
    if (amount) {
      // Convert amount to a number
      var number = parseFloat(Number(amount));

      // Format with commas as thousands separators
      var formattedAmount = number.toLocaleString('en-US', {
        minimumFractionDigits: 2,
      });

      return formattedAmount;
    } else {
      return 0;
    }
  };

  const ConvertTotoken = (e) => {
    setCoinAmount(e);
    let Coin = selected_radio;
    const amount = Coin === 'ETH' ? ethPrice : usdPrice;
    if (Coin === 'ETH') {
      return setTokenAmount(
        BigNumber(e)
          .multipliedBy(BigNumber(amount))
          .div(BigNumber(usdPrice))
          .toNumber(),
      );
    }
    setTokenAmount(BigNumber(e).div(BigNumber(amount)).toNumber());
  };

  const HandleSearch = (e) => {
    setSearch(e);

    const Datas = [...buysearchlisttransaction];
    let filetedsearch = Datas.filter(
      (a) =>
        a?.transactionHash?.toLowerCase().includes(e?.toLowerCase()) ||
        a?.amount?.toLowerCase().includes(e?.toLowerCase()) ||
        a?.tokenAmount?.toLowerCase().includes(e?.toLowerCase()),
    );

    setbuylisttransaction(filetedsearch);
  };

  const ClosePopupModal = async () => {
    setpoptext('');
    setpopupmodal(false);
  };

  const swapexchange = () => {
    setswap(!swap);
  };

  return (
    <>
      <Grid
        container
        sm={12}
        xs={12}
        display={'flex'}
        flexDirection={'row'}
        alignItems={'flex-start'}
        justifyContent={'center'}
        className="welcomeBG"
      >
        <Grid container position={'fixed'} zIndex={100}>
          <TopNavBar />
        </Grid>
        <Grid
          container
          sm={11}
          xs={12}
          display={'flex'}
          justifyContent={{ sm: 'space-between', xs: 'center' }}
          alignItems={'flex-start'}
          className={cx([
            'main_position',
            (!isWhitelisted || !isConnected) && 'blurredBG',
          ])}
        >
          <Grid item sm={7.9} xs={11} className="mt-2">
            {/* <Grid
              container
              lg={12}
              xs={12}
              display={'flex'}
              className="buynow_layer1 px-3"
            >
              <Grid
                item
                lg={12}
                xs={12}
                display={'flex'}
                flexDirection={{ md: 'row', xs: 'column' }}
                alignItems={'center'}
                justifyContent={{ sm: 'space-evenly', xs: 'center' }}
                className="buynow_infolayer mt-2 py-1"
              >
                {swap ? (
                  <Grid lg={4} md={5} xs={10} className="mt-2 mb-2">
                    <h4 className="text-center">{AmountFormat(tokenAmount)}</h4>
                    <Grid
                      display={'flex'}
                      flexDirection={'row'}
                      justifyContent={'center'}
                      alignItems={'center'}
                      className="BuyNowCardvalue rounded p-1 mt-3"
                    >
                      <img
                        src={SvgLogo}
                        alt="logo"
                        style={{ height: '30px', width: '180px' }}
                      />
                      <p className="text-light mx-2">OZK</p>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid lg={4} md={5} xs={10} className=" mb-2">
                    <Grid
                      item
                      lg={12}
                      xs={12}
                      display={'flex'}
                      flexDirection={'row'}
                      justifyContent={'center'}
                      className="mt-2 w-100 mb-2"
                    >
                      <Grid item className="">
                        <button
                          className="btn d-flex btn-0 w-100 p-0"
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                          }}
                          onClick={() => {
                            setSelected_radio('ETH');
                            setCoinAmount(0);
                            setTokenAmount(0);
                          }}
                        >
                          <InputRadio
                            size={'small'}
                            isChecked={selected_radio == 'ETH' ? true : false}
                          />{' '}
                          <h5 className="mx-2 m-0">ETH</h5>
                        </button>
                      </Grid>

                      <Grid item className="mx-3">
                        <button
                          className="btn btn-0  mx-auto w-100 p-0"
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                          }}
                          onClick={() => {
                            setSelected_radio('USDT');
                            setCoinAmount(0);
                            setTokenAmount(0);
                          }}
                        >
                          <InputRadio
                            size={'small'}
                            isChecked={selected_radio == 'USDT' ? true : false}
                          />{' '}
                          <h5 className="mx-1 m-0">USDT</h5>
                        </button>
                      </Grid>
                    </Grid>

                    <CustomText_input
                      placeholder={'Enter Amount'}
                      HandleInput={(e) => ConvertTotoken(e)}
                      Value={CoinAmount}
                      inputType={'number'}
                      height={'40px'}
                      maxLength={6}
                    />
                  </Grid>
                )}

                <Grid
                  display={'flex'}
                  alignItems={'center'}
                  justifyContent={'center'}
                  xs={1}
                  sx={{ cursor: 'pointer' }}
                  onClick={() => {
                    swapexchange();
                  }}
                  className="mt-2 mb-2"
                >
                  <span className="exchange_icon">
                    <GoArrowSwitch className="text-light" size={25} />
                  </span>
                </Grid>

                {swap ? (
                  <Grid lg={4} md={5} xs={10} className="mt-2 mb-2">
                    <Grid
                      item
                      lg={12}
                      xs={12}
                      display={'flex'}
                      flexDirection={'row'}
                      justifyContent={'center'}
                      className="w-100 mb-2"
                    >
                      <Grid item className="">
                        <button
                          className="btn d-flex btn-0 w-100 p-0"
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                          }}
                          onClick={() => {
                            setSelected_radio('ETH');
                            setCoinAmount(0);
                            setTokenAmount(0);
                          }}
                        >
                          <InputRadio
                            size={'small'}
                            isChecked={selected_radio == 'ETH' ? true : false}
                          />{' '}
                          <h5 className="mx-2 m-0">ETH</h5>
                        </button>
                      </Grid>

                      <Grid item className="mx-3">
                        <button
                          className="btn btn-0  mx-auto w-100 p-0"
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                          }}
                          onClick={() => {
                            setSelected_radio('USDT');
                            setCoinAmount(0);
                            setTokenAmount(0);
                          }}
                        >
                          <InputRadio
                            size={'small'}
                            isChecked={selected_radio == 'USDT' ? true : false}
                          />{' '}
                          <h5 className="mx-1 m-0">USDT</h5>
                        </button>
                      </Grid>
                    </Grid>
                    <CustomText_input
                      placeholder={'Enter Amount'}
                      HandleInput={(e) => ConvertTotoken(e)}
                      Value={CoinAmount}
                      inputType={'number'}
                      height={'40px'}
                      maxLength={6}
                    />
                  </Grid>
                ) : (
                  <Grid lg={4} md={5} xs={10} className="mt-2 mb-2">
                    <h4 className="text-center">{AmountFormat(tokenAmount)}</h4>
                    <Grid
                      display={'flex'}
                      flexDirection={'row'}
                      justifyContent={'center'}
                      alignItems={'center'}
                      className="BuyNowCardvalue rounded p-1 mt-3"
                    >
                      <img
                        src={SvgLogo}
                        alt="logo"
                        style={{ height: '30px', width: '180px' }}
                      />
                      <p className="text-light mx-2">OZK</p>
                    </Grid>
                  </Grid>
                )}
              </Grid>

              <Grid
                container
                display={'flex'}
                justifyContent={'center'}
                className="mt-3"
              >
                <Grid item lg={4}>
                  {endDate !== 0 &&
                  endDate <= Math.floor(new Date().getTime() / 1000) ? (
                    <CustomButton
                      text={'Buy Now'}
                      bordercolor={'#FFED8C'}
                      btnTextColor={'#FFED8C'}
                      btnColor={'#000000'}
                      disabled={true}
                    />
                  ) : (
                    <CustomButton
                      text={'Buy Now'}
                      bordercolor={'#FFED8C'}
                      btnTextColor={'#FFED8C'}
                      btnColor={'#000000'}
                      onClick={() => buyToken()}
                    />
                  )}
                </Grid>
              </Grid>

              <Grid
                container
                display={'flex'}
                flexDirection={'row'}
                justifyContent={'center'}
                alignItems={'center'}
                className="mt-2"
              >
                <Grid item>
                  <p className="align-item-center p-0 m-0 text-center">
                    Ensure you are connected to the Ethereum Mainnet. Do not send funds on any other network
                  </p>
                </Grid>
              </Grid>

              <Grid
                container
                display={'flex'}
                flexDirection={'row'}
                justifyContent={'center'}
                alignItems={'center'}
                className="mt-4"
              >
                <Grid item>
                  <MaterialCheckbox
                    checked={isChecked}
                    onChange={() => {
                      setIsChecked((prev) => !prev);
                    }}
                  />
                </Grid>
                <Grid item>
                  <p className="align-item-center p-0 m-0 text-center">
                    You have read and agree to the{' '}
                    <span
                      className="mx-1"
                      style={{ color: '#FC9C4A', cursor: 'pointer' }}
                      onClick={() => {
                        window.open(
                          '/pdf/OpenZK - Token T&Cs250410.pdf',
                          '_blank',
                        );
                      }}
                    >
                      Terms and Conditions of Token Sale and Usage
                    </span>
                   
                  </p>
                </Grid>
              </Grid>
              <Grid
                container
                display={'flex'}
                flexDirection={'row'}
                justifyContent={'center'}
                alignItems={'center'}
                className="mb-2"
              >
                <Grid item>
                  <MaterialCheckbox
                    checked={isDisclaimerChecked}
                    onChange={() => {
                      setIsDisclaimerChecked((prev) => !prev);
                    }}
                  />
                </Grid>
                <Grid item>
                  <p className="d-flex align-item-center p-0 m-0">
                    You have read and agree to the
                    <Grid
                      className="mx-1"
                      style={{ color: '#FC9C4A', cursor: 'pointer' }}
                      onClick={() => {
                        window.open(
                          '/pdf/OpenZK.-.Token.Disclaimers.250204.pdf',
                          '_blank',
                        );
                      }}
                    >
                      {' '}
                      Disclaimer{' '}
                    </Grid>{' '}
                  </p>
                </Grid>
              </Grid>
            </Grid> */}

            {/* Public Vesting Schedule STARTED */}
            <Grid
              container
              lg={12}
              display={'flex'}
              flexDirection={'row'}
              alignItems={'center'}
              justifyContent={'space-between'}
              className="p-3 comman_bg_layer"
            >
              <h5 className="text-light mt-2 w-100 text-left">
                Presale Participation Overview
              </h5>
              <Grid
                lg={5.9}
                md={5.9}
                sm={8}
                xs={12}
                display={'flex'}
                flexWrap={'wrap'}
                alignItems={'center'}
                justifyContent={'space-between'}
                className="buynow_inner_layer p-3 mt-2"
              >
                <Grid
                  item
                  lg={12}
                  display={'flex'}
                  flexWrap={'wrap'}
                  alignItems={'center'}
                  justifyContent={'space-between'}
                  width={'100%'}
                >
                  <p style={{ maxWidth: '50%' }}>OZK Purchase Price (perOZK)</p>
                  <p style={{ width: '50%' }} className="text-right">
                    USDT {usdPrice.toFixed(7)}
                  </p>
                </Grid>
                <Grid
                  item
                  lg={12}
                  display={'flex'}
                  flexWrap={'wrap'}
                  alignItems={'center'}
                  justifyContent={'space-between'}
                  className="mt-3"
                  width={'100%'}
                >
                  <p style={{ width: '50%' }}>Claimable Upon TGE</p>
                  <p style={{ width: '50%' }} className="text-right">
                    70%
                  </p>
                </Grid>
              </Grid>

              <Grid
                lg={5.9}
                md={5.9}
                sm={8}
                xs={12}
                display={'flex'}
                flexWrap={'wrap'}
                alignItems={'center'}
                justifyContent={'space-between'}
                className="buynow_inner_layer p-3 mt-2"
              >
                <Grid
                  item
                  lg={12}
                  display={'flex'}
                  flexWrap={'wrap'}
                  alignItems={'center'}
                  justifyContent={'space-between'}
                  width={'100%'}
                >
                  <p style={{ width: '50%' }}>Balance Claimable</p>
                  <p style={{ width: '50%' }} className="text-right">
                    30% over the 12 months folllowing TGE
                  </p>
                </Grid>
                <Grid
                  item
                  lg={12}
                  display={'flex'}
                  flexWrap={'wrap'}
                  alignItems={'center'}
                  justifyContent={'space-between'}
                  className="mt-3"
                  width="100%"
                >
                  <p style={{ width: '50%' }}>Vesting Frequency</p>
                  <p style={{ width: '50%' }} className="text-right">
                    Linear over 12 months
                  </p>
                </Grid>
              </Grid>

              <Grid item lg={12} xs={12} className="mt-2 p-2">
                <Grid
                  container
                  dispoolay={'flex'}
                  flexDirection={'row'}
                  alignItems={'center'}
                  justifyContent={'space-between'}
                >
                  <Grid item>
                    <h5>Transaction History</h5>
                  </Grid>
                  <Grid item>
                    <CustomText_input
                      placeholder={'Search...'}
                      icon={<IoSearchOutline className="text-light" />}
                      Value={Search}
                      HandleInput={(e) => HandleSearch(e)}
                    />
                  </Grid>
                </Grid>
                <Box className="w-100 mt-4">
                  <TableContainer
                    className="CustomScroll"
                    sx={{
                      border: '1px solid #FFFFFF1A',
                      borderRadius: '15px',
                      height: buylisttransaction?.length > 10 ? '70vh' : '30vh',
                    }}
                  >
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead root>
                        <StyledTableRow>
                          <TableCell
                            style={{
                              backgroundColor: '#3B3B3D',
                              color: '#FFF',
                              fontSize: '16px',
                              fontFamily: 'PoppinsSemiBold',
                            }}
                          >
                            Aggregate Purchase Price
                          </TableCell>
                          <TableCell
                            style={{
                              backgroundColor: '#3B3B3D',
                              color: '#FFF',
                              fontSize: '16px',
                              fontFamily: 'PoppinsSemiBold',
                            }}
                          >
                            Transaction Hash
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{
                              backgroundColor: '#3B3B3D',
                              color: '#FFF',
                              fontSize: '16px',
                              fontFamily: 'PoppinsSemiBold',
                            }}
                          >
                            OZK Purchased
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{
                              backgroundColor: '#3B3B3D',
                              color: '#FFF',
                              fontSize: '16px',
                              fontFamily: 'PoppinsSemiBold',
                            }}
                          >
                            Date & Time
                          </TableCell>
                        </StyledTableRow>
                      </TableHead>
                      <TableBody>
                        {!Loader ? (
                          buylisttransaction?.length > 0 ? (
                            buylisttransaction
                              ?.slice(
                                Page * RowsPerPage,
                                Page * RowsPerPage + RowsPerPage,
                              )
                              .map((row, i) => (
                                <StyledTableRow
                                  tabIndex={-1}
                                  key={i}
                                  sx={{
                                    backgroundColor:
                                      i % 2 !== 0 ? '#FFFFFF0F' : '#343435CC',
                                  }}
                                >
                                  <StyledTableCell>
                                    <Grid
                                      display={'flex'}
                                      flexDirection={'row'}
                                      alignItems={'center'}
                                    >
                                      <img
                                        src={
                                          row.saleType == 'ETH'
                                            ? ETHLogo
                                            : USDTLogo
                                        }
                                        alt="coin"
                                        style={{
                                          height: '25px',
                                          width: '25px',
                                          borderRadius: '25px',
                                        }}
                                      />
                                      <span className="mx-2">
                                        {row?.amount ? row?.amount : '----'}
                                      </span>
                                    </Grid>
                                  </StyledTableCell>
                                  <StyledTableCell>
                                    {' '}
                                    <CustomTooltip
                                      title={row.transactionHash}
                                      placement="right"
                                    >
                                      <a
                                        href={
                                          REACT_APP_TRANSACTION_HASHLINK +
                                          row?.transactionHash
                                        }
                                        target="blank"
                                        style={{ color: '#fff' }}
                                      >
                                        <p>
                                          {row?.transactionHash?.slice(0, 8) +
                                            '....' +
                                            row?.transactionHash?.slice(-8)}
                                        </p>
                                      </a>
                                    </CustomTooltip>
                                  </StyledTableCell>
                                  <StyledTableCell
                                    align="center"
                                    display={'flex'}
                                    flexDirection={'row'}
                                  >
                                    <img
                                      src={Enshield}
                                      alt="coin"
                                      style={{ height: '25px', width: '25px' }}
                                    />
                                    <span className="mx-2">
                                      {formatter.format(row?.tokenAmount)}
                                    </span>
                                  </StyledTableCell>
                                  <StyledTableCell align="center">
                                    {FormatDate(row.date)}
                                  </StyledTableCell>
                                </StyledTableRow>
                              ))
                          ) : (
                            <TableRow>
                              <StyledTableCell colSpan={8} align="center">
                                <p className="text-center text-light">
                                  Transaction History Available
                                </p>
                              </StyledTableCell>
                            </TableRow>
                          )
                        ) : (
                          <TableRow>
                            <StyledTableCell colSpan={8} align="center">
                              <Grid
                                container
                                display={'flex'}
                                flexDirection={'row'}
                                alignItems={'center'}
                                justifyContent={'center'}
                              >
                                <h5 className="m-0 p-0">Loading</h5>
                                <span className="regular mx-2">
                                  <CircularProgress
                                    style={{ color: '#FFFF' }}
                                  />
                                </span>
                              </Grid>
                            </StyledTableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {buylisttransaction?.length > 10 ? (
                    <Grid
                      container
                      lg={12}
                      display={'flex'}
                      flexDirection={'row'}
                      alignItems={'center'}
                      justifyContent={'flex-start'}
                    >
                      <Grid
                        item
                        lg={6}
                        display={'flex'}
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                      >
                        <CustomTablePagination
                          colSpan={8}
                          rowsPerPageOptions={[10, 25, 50]}
                          component="div"
                          count={buylisttransaction.length}
                          rowsPerPage={RowsPerPage}
                          page={Page}
                          onPageChange={HandleChangePage}
                          onRowsPerPageChange={HandleChangeRowsPerPage}
                          labelRowsPerPage={null}
                        />
                      </Grid>
                      <Grid
                        item
                        lg={6}
                        display={'flex'}
                        justifyContent={'flex-end'}
                        alignItems={'flex-end'}
                      >
                        <Pagination
                          onPageChange={HandleChangePagePrev}
                          onRowsPerPageChange={HandleChangeRowsPerPage}
                          variant="outlined"
                          shape="rounded"
                          count={Math.ceil(
                            buylisttransaction.length / RowsPerPage,
                          )}
                          page={Page1}
                          onChange={HandleChangePagePrev}
                        />
                      </Grid>
                    </Grid>
                  ) : (
                    ''
                  )}
                </Box>
              </Grid>
            </Grid>

            {/* Public Vesting Schedule ENDED */}
          </Grid>

          <Grid
            item
            sm={4}
            xs={11}
            display={'flex'}
            flexDirection={'column'}
            alignItems={'center'}
            justifyContent={'center'}
            className="mt-2"
          >
            <Grid
              container
              display={'flex'}
              alignItems={'center'}
              justifyContent={'center'}
              className="buynow_timer p-3"
            >
              {startDate === 0 || !endDate ? (
                <h4 className="py-2" style={{ color: '#FFCB9E' }}>
                  Presale Not Yet Started
                </h4>
              ) : endDate < Math.floor(new Date().getTime() / 1000) ? (
                <h4 className="py-2" style={{ color: '#FFCB9E' }}>
                  Presale Completed
                </h4>
              ) : (
                <>
                  <h4 className="py-2" style={{ color: '#FFCB9E' }}>
                    Presale Ends in
                  </h4>
                  <Grid
                    container
                    lg={10}
                    display={'flex'}
                    flexDirection={'row'}
                    alignItems={'center'}
                    justifyContent={'space-evenly'}
                    className="mt-4"
                  >
                    <Grid
                      lg={2}
                      xs={2.8}
                      container
                      display={'flex'}
                      flexDirection={'column'}
                      alignItems={'center'}
                      justifyContent={'center'}
                    >
                      <Grid container className="TimerBox py-3">
                        <h3 className="font-weight-bold text-light m-0 ">
                          {RemainingTime?.days ? RemainingTime?.days : '00'}
                        </h3>
                      </Grid>
                      <p className="text-light  py-2">DAYS</p>
                    </Grid>
                    <Grid
                      lg={2}
                      xs={2.8}
                      container
                      display={'flex'}
                      flexDirection={'column'}
                      alignItems={'center'}
                      justifyContent={'center'}
                    >
                      <Grid container className="TimerBox py-3">
                        <h3 className="font-weight-bold text-light m-0 ">
                          {RemainingTime?.hours ? RemainingTime?.hours : '00'}
                        </h3>
                      </Grid>
                      <p className="text-light  py-2">HOURS</p>
                    </Grid>
                    <Grid
                      lg={2}
                      xs={2.8}
                      container
                      display={'flex'}
                      flexDirection={'column'}
                      alignItems={'center'}
                      justifyContent={'center'}
                    >
                      <Grid container className="TimerBox py-3">
                        <h3 className="font-weight-bold text-light m-0 ">
                          {RemainingTime?.minutes
                            ? RemainingTime?.minutes
                            : '00'}
                        </h3>
                      </Grid>
                      <p className="text-light  py-2">MINUTES</p>
                    </Grid>
                    <Grid
                      lg={2}
                      xs={2.8}
                      container
                      display={'flex'}
                      flexDirection={'column'}
                      alignItems={'center'}
                      justifyContent={'center'}
                    >
                      <Grid container className="TimerBox py-3">
                        <h3 className="font-weight-bold text-light m-0 ">
                          {RemainingTime?.seconds
                            ? RemainingTime?.seconds
                            : '00'}
                        </h3>
                      </Grid>
                      <p className="text-light  py-2">SECONDS</p>
                    </Grid>
                  </Grid>
                </>
              )}
            </Grid>
            {/* Wallet Balance  STARTED*/}
            <Grid
              container
              display={'flex'}
              flexDirection={'row'}
              alignItems={'center'}
              justifyContent={{ sm: 'space-between', xs: 'center' }}
              className="p-3 comman_bg_layer mt-3"
            >
              <h5 className="text-light mt-2 w-100 text-left">
                {' '}
                Wallet Balance
              </h5>

              <Grid
                sm={5.9}
                xs={5.9}
                display={'flex'}
                flexWrap={'wrap'}
                alignItems={'center'}
                justifyContent={'center'}
                className="mt-3 mb-2"
              >
                <Grid
                  item
                  xs={12}
                  sm={12}
                  display={'flex'}
                  justifyContent={'center'}
                  alignItems={'center'}
                >
                  <img
                    src={ETHLogo}
                    alt="ETH"
                    style={{
                      height: '30px',
                      width: '30px',
                      borderRadius: '25px',
                    }}
                  />
                  <h5 className="text-light mt-2 mx-2">ETH</h5>
                </Grid>
                <Grid
                  item
                  display={'flex'}
                  alignItems={'center'}
                  justifyContent={'space-between'}
                  className="mt-2"
                >
                  <p>{formatter.format(ethWalletBalance)} ETH</p>
                </Grid>
              </Grid>
              <Grid
                sm={5.9}
                xs={5.9}
                display={'flex'}
                flexWrap={'wrap'}
                alignItems={'center'}
                justifyContent={'center'}
                className=" mt-3 mb-2"
              >
                <Grid
                  item
                  xs={12}
                  sm={12}
                  display={'flex'}
                  justifyContent={'center'}
                  alignItems={'center'}
                >
                  <img
                    src={USDTLogo}
                    alt="USDT"
                    style={{
                      height: '30px',
                      width: '30px',
                      borderRadius: '25px',
                    }}
                  />
                  <h5 className="text-light mt-2 mx-2">USDT</h5>
                </Grid>
                <Grid
                  item
                  display={'flex'}
                  alignItems={'center'}
                  justifyContent={'space-between'}
                  className="mt-2"
                >
                  <p>{formatter.format(usdtWalletBalance)} USDT</p>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              container
              display={'flex'}
              flexDirection={'row'}
              alignItems={'center'}
              justifyContent={{ sm: 'space-between', xs: 'center' }}
              className="p-3 comman_bg_layer mt-3"
            >
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                display={'flex'}
                flexDirection={{ xs: 'row', sm: 'column', md: 'row' }}
                gap={{ sm: '1rem' }}
                alignItems={'center'}
                justifyContent={'space-between'}
                className="w-100"
              >
                <Grid
                  item
                  lg={5.8}
                  md={5.8}
                  sm={12}
                  xs={5.8}
                  display={'flex'}
                  flexDirection={'column'}
                  alignItems={'center'}
                  justifyContent={'center'}
                  className="welcomePage_Innercol2 w-100"
                >
                  <p className="text-light pt-2">Token Name</p>
                  <p className="text-light py-2">OZK</p>
                </Grid>

                <Grid
                  item
                  lg={5.8}
                  md={5.8}
                  sm={12}
                  xs={5.8}
                  display={'flex'}
                  flexDirection={'column'}
                  alignItems={'center'}
                  justifyContent={'space-between'}
                  className="welcomePage_Innercol2 w-100"
                >
                  <p className="text-light pt-2">Total Supply</p>
                  <p className="text-light py-2">15 Billion</p>
                </Grid>
              </Grid>

              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                display={'flex'}
                flexDirection={{ xs: 'row', sm: 'column', md: 'row' }}
                gap={{ sm: '1rem' }}
                alignItems={'center'}
                justifyContent={'space-between'}
                className="mt-4 w-100"
              >
                <Grid
                  item
                  lg={5.8}
                  md={5.8}
                  sm={12}
                  xs={5.8}
                  display={'flex'}
                  flexDirection={'column'}
                  alignItems={'center'}
                  justifyContent={'center'}
                  className="welcomePage_Innercol2 w-100"
                >
                  <p className="text-light pt-2">OZK Purchase Price</p>
                  <p className="text-light py-2">USDT {usdPrice.toFixed(7)}</p>
                </Grid>

                <Grid
                  item
                  lg={5.8}
                  md={5.8}
                  sm={12}
                  xs={5.8}
                  display={'flex'}
                  flexDirection={'column'}
                  alignItems={'center'}
                  justifyContent={'space-between'}
                  className="welcomePage_Innercol2 w-100"
                >
                  <p className="text-light pt-2">Accepted</p>
                  <Grid
                    item
                    display={'flex'}
                    flexDirection={'row'}
                    alignItems={'center'}
                    justifyContent={'center'}
                    className="py-2"
                  >
                    <img
                      src={ETHLogo}
                      style={{
                        width: '20px',
                        height: '20px',
                        borderRadius: '25px',
                      }}
                      alt="ethlogo"
                      className="mx-2"
                    />
                    <img
                      src={USDTLogo}
                      style={{
                        width: '20px',
                        height: '20px',
                        borderRadius: '25px',
                      }}
                      alt="usdtlogo"
                      className="mx-2"
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <div className="p-2 w-100" />
        </Grid>
        <CustomModal
          open={BuyNowModal}
          setOpen={setBuyNowModal}
          closebtn={'remove'}
          width={{ lg: '30%', md: '30%', xs: '90%', sm: '90%' }}
          modalContent={
            <Grid
              container
              display={'flex'}
              alignItems={'center'}
              justifyContent={'center'}
            >
              <Grid
                item
                lg={12}
                display={'flex'}
                alignItems={'center'}
                justifyContent={'center'}
                className="mt-3"
              >
                {selected_radio == 'ETH' ? (
                  <img
                    src={ETHLogo}
                    style={{
                      width: '30px',
                      height: '30px',
                      borderRadius: '25px',
                    }}
                    alt="OCOCIon"
                  />
                ) : (
                  <img
                    src={USDTLogo}
                    style={{
                      width: '30px',
                      height: '30px',
                      borderRadius: '25px',
                    }}
                    alt="OCOCIon"
                  />
                )}

                <h5 className="mx-2 mt-2">{AmountFormat(CoinAmount)}</h5>
                <h5 className="mx-2 mt-2"> = </h5>
                <img src={OCOCIon} alt="OCOCIon" />
                <h5 className="mx-2 mt-2">{AmountFormat(tokenAmount)}</h5>
              </Grid>
              <Grid
                item
                lg={12}
                display={'flex'}
                alignItems={'center'}
                justifyContent={'center'}
              >
                <Grid item className="p-2 mt-3">
                  <CustomButton
                    text={'Cancel'}
                    bordercolor={'rgba(255, 255, 255, 0.5)'}
                    onClick={() => setBuyNowModal(false)}
                  />
                </Grid>
                <Grid item className="p-2 mt-3">
                  <GradiantButton
                    text={'CONFIRM'}
                    borderColor={'#FFED8C'}
                    btnTextColor={'#FFED8C'}
                    btnColor={'#000000'}
                    onClick={() => ConfirmedBuyNow()}
                  />
                </Grid>
              </Grid>
            </Grid>
          }
        />

        <CustomModal
          open={WalletActionModal}
          closebtn={'remove'}
          modalTitle={<h5>Wallet Actions</h5>}
          width={{ lg: '30%', md: '30%', sm: '90%', xs: '90%' }}
          modalContent={
            <Grid
              container
              lg={12}
              display={'flex'}
              flexDirection={'row'}
              alignItems={'center'}
              justifyContent={'center'}
            >
              <Grid
                container
                lg={12}
                display={'flex'}
                flexDirection={'row'}
                alignItems={'center'}
                justifyContent={'space-between'}
                className=" GlassCardWhite p-3"
              >
                <Grid className="d-flex">
                  <p>
                    {' '}
                    <CiWallet className="text-light mx-2" size={30} /> Request
                    to Send Wallet
                  </p>
                </Grid>

                {Loader1 ? (
                  <span>
                    <CircularProgress fourColor size={20} />
                  </span>
                ) : (
                  <p>
                    {' '}
                    <IoMdCheckmarkCircleOutline size={20} />
                  </p>
                )}
              </Grid>
              <Grid
                container
                lg={12}
                display={'flex'}
                flexDirection={'row'}
                alignItems={'center'}
                justifyContent={'space-between'}
                className=" GlassCardWhite p-3 mt-3"
              >
                <Grid className="d-flex">
                  <p>
                    <TbRefreshDot className="text-light mx-2" size={30} />
                    Transaction Underway
                  </p>
                </Grid>

                {Loader2 ? (
                  <span>
                    <CircularProgress fourColor size={20} />
                  </span>
                ) : (
                  <p>
                    {' '}
                    <IoMdCheckmarkCircleOutline size={20} />
                  </p>
                )}
              </Grid>
              <Grid
                container
                lg={12}
                display={'flex'}
                flexDirection={'row'}
                alignItems={'center'}
                justifyContent={'space-between'}
                className=" GlassCardWhite p-3 mt-3"
              >
                <Grid className="d-flex">
                  <p>
                    {' '}
                    <IoMdSpeedometer className="text-light mx-2" size={30} />
                    Waiting for Confirmation
                  </p>
                </Grid>

                {Loader3 ? (
                  <span>
                    <CircularProgress fourColor size={20} />
                  </span>
                ) : (
                  <p>
                    {' '}
                    <IoMdCheckmarkCircleOutline size={20} />
                  </p>
                )}
              </Grid>

              {!Loader3 ? (
                <Grid
                  container
                  lg={12}
                  display={'flex'}
                  flexDirection={'row'}
                  alignItems={'center'}
                  justifyContent={'center'}
                  className=" GlassCardWhite p-3 mt-3"
                >
                  <Grid className="d-flex align-items-center">
                    <img
                      src={SvgLogo}
                      alt="logo"
                      style={{ height: '30px', width: '30px' }}
                    />
                    <p className="mx-2">
                      {AmountFormat(tokenAmount)} Purchased . Wait For TGE
                    </p>
                  </Grid>
                </Grid>
              ) : (
                ''
              )}
              {!Loader3 ? (
                <Grid
                  container
                  lg={12}
                  display={'flex'}
                  flexDirection={'row'}
                  alignItems={'center'}
                  justifyContent={'center'}
                  className="mt-3 w-100 "
                >
                  <GradiantButton
                    btnTextColor="#FFF"
                    text={'CHECK IN SCAN'}
                    borderColor={'#ffff'}
                    width="100%"
                    onClick={() => {
                      CheckinScan(Hashlink);
                    }}
                  />
                </Grid>
              ) : (
                ''
              )}
            </Grid>
          }
        />

        <PopUpModal
          popupmodal={popupmodal}
          poptext={poptext}
          handleClose={ClosePopupModal}
        />
      </Grid>
      {(!isConnected || !isWhitelisted) && (
        <NotConnectedModal
          open={modalOpen}
          setOpen={setModalOpen}
          modalContent={modalContent}
          modalTitle=""
          width={{ lg: '30%', md: '30%', sm: '90%', xs: '90%' }}
        />
      )}
    </>
  );
};

export default BuyNow;
